// extracted by mini-css-extract-plugin
var _1 = "ShowProblem__bg--PyND6";
var _2 = "ShowProblem__container--YFPgG";
var _3 = "ShowProblem__main--Ni9T1";
export { _1 as "bg", _2 as "container", _3 as "main" }
